<template>
	<modal
		title="Update information for selected participants"
		id="substudy-participants-update"
		cancel-label="Cancel"
		continue-label="Continue"
		:showModal="showModal"
		v-on:closed="cancelUpdate()"
		v-on:confirm="saveUpdate()"
	>
		<template v-slot:body>
			<div class="form-group row">
				<div class="col-sm-2"><label for="eligibility_id">Eligibility: </label></div>
				<div class="col-sm-10">
					<select v-model="newInfo.eligibility_id" class="form-control">
						<option value="">Select&hellip;</option>
						<option 
							v-for="elig in eligibilities" 
							:value="elig.id" 
							:key="elig.id"
						>
							{{ elig.name }}
						</option>
					</select>
				</div>
			</div>
			<div class="form-group row">
				<div class="col-sm-2"><label for="eligibility_id">Status: </label></div>
				<div class="col-sm-10">
					<select v-model="newInfo.substudy_status_id" class="form-control">
						<option value="">Select&hellip;</option>
						<option v-for="status in statuses" :value="status.id" :key="status.id">{{ status.name }}</option>
					</select>
				</div>
			</div>
		</template>
	</modal>
</template>

<script setup >
	import { ref, watch } from 'vue'
	import Modal from '../Modal.vue';

	const props = defineProps(['showModal'])
	const emit = defineEmits(['closed', 'input', 'confirm'])

	const newInfo = ref({ eligibility_id: null, substudy_status_id: null })
	const eligibilities = [
					{ id: 1, name: 'Eligible' },
					{ id: 2,  name: 'Ineligible' },
					{ id: 3, name: 'N/A' }
				]
	const statuses = [
					{ id: 1, name: 'Enrolled' },
					{ id: 2, name: 'Declined' },
					{ id: 3, name: 'Completed' },
					{ id: 4, name: 'Withdrawn' },
					{ id: 5, name: 'DK' },
				]

	// watch(participant, (to, from) => {
	// 	if (to != from) {
	// 		newInfo.value = {
	// 			eligibility_id: (participant.value.eligibility) ? participant.value.eligibility.id : null,
	// 			substudy_status_id: (participant.value.substudy_status) ? participant.value.substudy_status.id : null
	// 		}
	// 	}
	// }) 

	function cancelUpdate() {
		newInfo.value.eligibility_id = ''
		newInfo.value.substudy_status_id = ''
		emit('closed')
		emit('input', false);
	}

	function saveUpdate() {
		let data = {}
		data.eligibility_id = newInfo.value.eligibility_id
		data.substudy_status_id = newInfo.value.substudy_status_id
		emit('confirm', data)
		newInfo.value.eligibility_id = ''
		newInfo.value.substudy_status_id = ''
		emit('input', false)
	}
</script>